import roundTime from '@utils/round-time'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/endOfDay'
import subMinutes from 'date-fns/subMinutes'

import { ReportSearchPresetService, ReportService, ReportFiles } from '@common/ApiService'
import { updateField } from '../helpers'

import { s3FileOpener } from '@utils/file-opener'
import paginationHeaders from '@utils/pagination-headers'

const REPORT_SEARCH_PRESET_SUCCESS = 'REPORT_SEARCH_PRESET_SUCCESS'
const REPORT_SEARCH_PRESETS_SUCCESS = 'REPORTS_SEARCH_PRESET_SUCCESS'
const REPORT_SEARCH_PRESET_ERROR = 'REPORT_SEARCH_PRESET_ERROR'
const UPDATE_STATIONS_LIST = 'UPDATE_STATIONS_LIST'
const CLEAR_STATIONS_LIST = 'CLEAR_STATIONS_LIST'
const REPORT_SEARCH_PRESET_CLEAR = 'REPORT_SEARCH_PRESET_CLEAR'
const CLEAR_RESULTS = 'CLEAR_RESULTS'
const REPORTS_SUCCESS = 'REPORTS_SUCCESS'
const REPORTS_ERROR = 'REPORTS_ERROR'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
const REPORT_CLEAR_FILTER_VALUES = 'REPORT_CLEAR_FILTER_VALUES'
const REPORT_PROGRESS = 'REPORT_PROGRESS'
const BOOKING_LIMIT = 'BOOKING_LIMIT'
const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
const SET_ILLEGAL_FILTERS = 'SET_ILLEGAL_FILTERS'
const GET_REPORT_FILES = 'GET_REPORT_FILES'
const REPORT_FILES_ERROR = 'REPORT_FILES_ERROR'

export const state = {
  legs: [],
  pagination: {
    total: 0,
    page: 1,
  },
  filterOptions: {},
  illegalFilters: {},
  report_search_presets: [],
  report_search_preset: {
    scheduled_departure: startOfDay(new Date()),
    scheduled_arrival: subMinutes(roundTime(endOfDay(new Date())), 5),
    seats_only: null,
    consent_given: null,
    name: null,
    booking_source: [],
    booking_ref: null,
    status: [],
    pre_booked: null,
    rsid: null,
    head_code: null,
    customer_name: null,
    customer_email: null,
    customer_postcode: null,
    customer_phone: null,
    report_type: null,
    booked_by: null,
    user_bodies: [],
    sfo_id: null,
    station_list: [],
    journey_assistances: [],
    assistance_categories: [],
    customer_access_considerations: [],
    incomplete_reasons: [],
    created_by_organisation: null,
    booking_status: [],
    booking_type: [],
    report_max_days: 366,
  },
  errors: {},
  tooManyBookings: false,
  reportDownloadFinished: false,
  progress: '',
  reportFiles: [],
  timestamp: new Date().getTime(),
}

export const getters = {}

export const mutations = {
  updateField,

  [GET_REPORT_FILES](state, data) {
    state.reportFiles = data
  },

  [REPORT_FILES_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },

  [SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },

  [SET_ILLEGAL_FILTERS](state, data) {
    state.illegalFilters = data
  },

  [REPORT_SEARCH_PRESETS_SUCCESS](state, data) {
    state.report_search_presets = data
    return state
  },

  [REPORT_SEARCH_PRESET_SUCCESS](state, data) {
    state.report_search_preset = data
    state.report_search_preset.scheduled_departure = roundTime(new Date(data.scheduled_departure))
    state.report_search_preset.scheduled_arrival = roundTime(new Date(data.scheduled_arrival))
    return state
  },

  [UPDATE_STATIONS_LIST](state, station) {
    if (state.report_search_preset.station_list.indexOf(station) === -1) {
      state.report_search_preset.station_list.push(station)
    }
    return state
  },

  [CLEAR_STATIONS_LIST](state) {
    state.report_search_preset.station_list = []
    return state
  },

  [REPORT_SEARCH_PRESET_CLEAR](state) {
    state.report_search_preset = {
      scheduled_departure: startOfDay(new Date()),
      scheduled_arrival: subMinutes(roundTime(endOfDay(new Date())), 5),
      seats_only: '',
      consent_given: '',
      name: '',
      booking_source: [],
      booking_ref: '',
      status: [],
      pre_booked: '',
      rsid: '',
      head_code: '',
      customer_name: '',
      customer_email: '',
      customer_postcode: '',
      customer_phone: '',
      user_bodies: [],
      sfo_id: null,
      station_list: [],
      journey_assistances: [],
      assistance_categories: [],
      customer_access_considerations: [],
      report_type: '',
      booked_by: '',
      incomplete_reasons: [],
      created_by_organisation: '',
      booking_status: [],
      booking_type: [],
    }

    return state
  },

  [REPORT_SEARCH_PRESET_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },

  [REPORTS_SUCCESS](state, data) {
    state.legs = data
    return state
  },

  [CLEAR_RESULTS](state) {
    state.legs = []
    state.pagination.total = 0
    return state
  },

  [UPDATE_PAGINATION](state, response) {
    state.pagination = paginationHeaders(response)
    return state
  },

  [REPORTS_ERROR](state, data) {
    if (data?.response?.data?.error === 'booking_limit') {
      state.tooManyBookings = true
    }

    state.errors = data
    state.progress = 'error'
    return state
  },

  [REPORT_CLEAR_FILTER_VALUES](state, defaultValues) {
    state.report_search_preset = {
      ...state.report_search_preset,
      seats_only: '',
      consent_given: '',
      name: '',
      booking_source: [],
      booking_ref: '',
      status: [],
      assistance_status: [],
      assignment_status: [],
      pre_booked: '',
      rsid: '',
      head_code: '',
      customer_name: '',
      customer_email: '',
      customer_postcode: '',
      customer_phone: '',
      sfo_id: null,
      station_list: [],
      booked_by: '',
      incomplete_reasons: [],
      created_by_organisation: '',
      booking_status: [],
      user_bodies: [],
      booking_type: [],
    }
    state.report_search_preset.user_bodies = [...defaultValues.userBodies]
    state.report_search_preset.journey_assistances = [...defaultValues.journeyAssistances]
    state.report_search_preset.assistance_categories = [...defaultValues.assistanceCategories]
    state.report_search_preset.customer_access_considerations = [...defaultValues.accessConsiderations]
    state.report_search_preset.booking_type = [...defaultValues.bookingType]
    state.report_search_preset.booking_status = [...defaultValues.bookingStatus]
    state.report_search_preset.status = [...defaultValues.journeyStatus]
    if (defaultValues.assistanceStatus) {
      state.report_search_preset.assistance_status = [...defaultValues.assistanceStatus]
    }
    if (defaultValues.assignmentStatus) {
      state.report_search_preset.assignment_status = [...defaultValues.assignmentStatus]
    }

    return state
  },

  [REPORT_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },

  [BOOKING_LIMIT](state, status = false) {
    state.tooManyBookings = status
    return state
  },
}

export const actions = {
  createReportPreset({ commit }, newReport) {
    return ReportSearchPresetService.create({
      ...newReport,
    }).then((response) => {
      commit(REPORT_SEARCH_PRESET_SUCCESS, response.data)
    })
  },

  fetchReportSearchPresetSearchPresets({ commit }, query) {
    return ReportSearchPresetService.query(query)
      .then((response) => {
        commit(REPORT_SEARCH_PRESETS_SUCCESS, response.data)
      })
      .catch((error) => commit(REPORT_SEARCH_PRESET_ERROR, error))
  },

  fetchReportSearchPreset({ commit }, id) {
    return ReportSearchPresetService.get(id)
      .then((response) => {
        commit(REPORT_SEARCH_PRESET_SUCCESS, response.data)
      })
      .catch((error) => commit(REPORT_SEARCH_PRESET_ERROR, error))
  },

  fetchReportFiles({ commit }) {
    return ReportFiles.index()
      .then((response) => {
        commit(GET_REPORT_FILES, response.data)
      })
      .catch((error) => {
        commit(REPORT_FILES_ERROR, error)
      })
  },

  cancelReportFileGeneration({ commit }, id) {
    return ReportFiles.cancel(id).catch((error) => {
      commit(REPORT_FILES_ERROR, error)
    })
  },

  fetchFilterOptions({ commit }) {
    return ReportService.filterOptions().then((response) => {
      commit(SET_FILTER_OPTIONS, response.data)
    })
  },

  fetchIllegalFilters({ commit }) {
    return ReportService.illegalFilters().then((response) => {
      commit(SET_ILLEGAL_FILTERS, response.data)
    })
  },

  destroyReportSearchPreset({ commit }, id) {
    return ReportSearchPresetService.destroy(id).catch((error) => {
      commit(REPORT_SEARCH_PRESET_ERROR, error)
    })
  },

  updateStationList({ commit }, station) {
    commit(UPDATE_STATIONS_LIST, station)
  },

  clearStationList({ commit }) {
    commit(CLEAR_STATIONS_LIST)
  },

  clearReportSearchPreset({ commit }) {
    commit(REPORT_SEARCH_PRESET_CLEAR)
  },

  clearFilterValues({ commit }, defaultValues) {
    commit(REPORT_CLEAR_FILTER_VALUES, defaultValues)
  },

  searchLegs({ commit }, params) {
    return new Promise((resolve) => {
      commit(REPORT_PROGRESS, 'search_loading')
      return ReportService.search({
        ...params,
        print: false,
        format: 'json',
      })
        .then((response) => {
          commit(REPORTS_SUCCESS, response.data)
          commit(UPDATE_PAGINATION, response)
          commit(REPORT_PROGRESS, 'search_legs_success')
          resolve(response.data)
        })
        .catch((error) => commit(REPORTS_ERROR, error))
    })
  },

  clearResults({ commit }) {
    commit(CLEAR_RESULTS)
  },

  generateReport({ commit }, params) {
    commit(REPORT_PROGRESS, 'report_loading')
    return ReportService.generate({
      ...params,
      format: 'json',
      print: false,
      export_type: params.format,
    })
      .then((response) => {
        commit(REPORT_PROGRESS, 'report_loading_success')
        return response
      })
      .catch((error) => {
        commit(REPORTS_ERROR, error)
        throw error
      })
  },

  printReport({ commit }, params) {
    commit(REPORT_PROGRESS, 'report_loading')
    return ReportService.generate({
      ...params,
      format: 'json',
      print: true,
      export_type: params.format,
    }).catch((error) => commit(REPORTS_ERROR, error))
  },

  downloadReport(_, { link, type }) {
    return s3FileOpener(link, type)
  },

  activateBookingLimit({ commit }, status) {
    commit(BOOKING_LIMIT, status)
  },
}
